<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkDataTable from "./BookmarkDataTable.svelte";
  import Card from "../../Core/Card.svelte";
  import { DataTables } from "../../../utils/Constant/Constant";
  import { tableData } from "../../../Data/Table/DataTables/DataTables";
  import { Datatable } from "svelte-simple-datatables";
  import {
    CompanyName,
    Contact,
    Country,
    CreateOn,
    ID,
    Name,
    Status,
  } from "../../../utils/Constant/Constant";

  const settings = {
    pagination: true,
    scrollY: true,
    scrollX: true,
    rowsPerPage: 10,
    sortable: true,
  };
  let rows:any;
</script>

<BookmarkDataTable />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card headerTitle={DataTables} cardHeaderprops="pb-0">
        <div slot="contentbody" class="data-table simpal-data-table">
          <div class="dataTable-wrapper">
            <Datatable {settings} data={tableData} bind:dataRows={rows}>
              <thead>
                <th data-key="id">{ID}</th>
                <th data-key="name">{Name}</th>
                <th data-key="status">{Status}</th>
                <th data-key="companyName">{CompanyName}</th>
                <th data-key="contact">{Contact}</th>
                <th data-key="country">{Country}</th>
                <th data-key="create_on">{CreateOn}</th>
              </thead>
              <tbody>
                {#if rows}
                  {#each $rows as row}
                    <tr>
                      <td style="text-align:center;padding:4px 0">{row.id}</td>
                      <td style="text-align:center;padding:4px 0">
                        {row.name}
                      </td>
                      <td style="text-align:center;padding:4px 0">
                        <div>
                          {@html row.status}
                        </div>
                      </td>
                      <td style="text-align:center;padding:4px 0">
                        {row.companyName}
                      </td>
                      <td style="text-align:center;padding:4px 0">
                        {row.contact}
                      </td>
                      <td style="text-align:center;padding:4px 0">
                        {row.country}
                      </td>
                      <td style="text-align:center;padding:4px 0">
                        {row.create_on}
                      </td>
                    </tr>
                  {/each}
                {/if}
              </tbody>
            </Datatable>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>
